import { FraudOutcome } from '@interfaces/fraud-detector/fraud-detector.interface';
import { Action, createReducer, on } from '@ngrx/store';

import { UpdateFraudDetectorSimulatorLevel } from '../../actions';

export { FraudOutcome };

export interface IFraudDetectorSimulatorState {
  level: FraudOutcome;
  options: IFraudDetectorSimulatorOptions[];
}

export interface IFraudDetectorSimulatorOptions {
  key: string;
  value: string;
}

export const DEFAULT_FRAUD_DETECTOR_MOCK_LEVEL_OPTIONS: IFraudDetectorSimulatorOptions[] =
  Object.keys(FraudOutcome).map((key) => ({
    key,
    value: FraudOutcome[key],
  }));

export const INITIAL_STATE: IFraudDetectorSimulatorState = {
  level: FraudOutcome.LEGIT,
  options: DEFAULT_FRAUD_DETECTOR_MOCK_LEVEL_OPTIONS,
};

const fraudDetectorSimulatorReducer = createReducer(
  INITIAL_STATE,
  on(UpdateFraudDetectorSimulatorLevel, (state, prop) => {
    return {
      ...state,
      level: prop.level as FraudOutcome,
    };
  }),
);

export function reducer(state: IFraudDetectorSimulatorState | undefined, action: Action) {
  return fraudDetectorSimulatorReducer(state, action);
}
